import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { ContactService } from '../../contact.service';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss']
})
export class OrderDetailsComponent implements OnInit {
  orderDetail:any=[];

  constructor(public dialogRef: MdDialogRef<OrderDetailsComponent>,@Inject(MD_DIALOG_DATA) public data: any,private contactService: ContactService) { 

    this.orderDetail  = this.data ;
    console.log("this.payloadObj",this.orderDetail); 
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/product-shop/order-details/order-details.component.ts